import type React from 'react';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import {
	HeroTitle,
	SapIssueForm,
	Tagline,
	TopImpactStoriesDesktop,
	TopImpactStoriesMobile,
	TopImpactStoriesMobileProvider,
} from '#src/app/pages/homepage/shared/components';

export const HeroSectionIssuePrompt: React.FC = () => {
	const {
		data: { topImpactStories },
	} = useHomepagePageData();

	return (
		<section data-testid="homepage-input-hero-section" className="text-typography-strong relative">
			<div className="relative z-10 container pt-6 md:pt-11 lg:pt-15">
				<div>
					<HeroTitle className="m-0 text-center" />
					<SapIssueForm />
					<Tagline />
				</div>

				{topImpactStories.length > 0 && <TopImpactStoriesDesktop layout="row" />}
			</div>
			{topImpactStories.length > 0 && (
				<TopImpactStoriesMobileProvider>
					<TopImpactStoriesMobile />
				</TopImpactStoriesMobileProvider>
			)}
		</section>
	);
};
